// eslint-disable-next-line import/prefer-default-export
export const SIDEBAR = {
  menu: {
    sales: 'Sales',
    quotation: 'Quotes',
    customers: 'Customers',
  },
};
